export const config = {
  apiKey: "AIzaSyAOv2-dENsFi4tjhgMnr_pWFViDZ9fIxnY",
  authDomain: "app.withaview.co",
  databaseURL: "https://prod-eu-wav.firebaseio.com",
  projectId: "prod-eu-wav",
  storageBucket: "prod-eu-wav.appspot.com",
  messagingSenderId: "615026429269",
  appId: "1:615026429269:web:abb4aaec25e891ad0ab3dc",
  measurementId: "G-M8G98775ZW"

  // apiKey: "AIzaSyCAuUeTdGQXpiV_2xru-pX4460Er0yK-Do",
  // authDomain: "dev-wav.firebaseapp.com",
  // databaseURL: "https://dev-wav.firebaseio.com",
  // projectId: "dev-wav",
  // storageBucket: "dev-wav.appspot.com",
  // messagingSenderId: "170508625596",
  // storageBucket: 'dev-wav.appspot.com'
}



// WEBPACK FOOTER //
// ./src/firebase/config.js